<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">Orders Written Report</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          responsiveLayout="scroll"
          [value]="filterOrdersWrittenReportDetailLists"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="defaultTake"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [autoLayout]="true"
          [resizableColumns]="true"
          [paginator]="ordersWrittenReportDetailLists.length >= 20"
          [lazy]="true"
          (onLazyLoad)="getOrdersWrittenReportDetail($event)"
          [totalRecords]="totalRecords"
          stripedRows
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          styleClass="table-listing"
          [globalFilterFields]="[
            'salesOrderIdD365',
            'salesOrderStatusD365',
            'customerName',
          ]">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th>Sale Order</th>
              <th>Created Date</th>
              <th>Client Name</th>
              <th>Job Name</th>
              <th>IHD</th>
              <th>Branding Consultant</th>
              <th>Account Coordinator</th>
              <th>Status</th>
              <th>Highest Net Vendor</th>
              <th>Currency</th>
              <th>Order Total</th>
              <th>Commission</th>
              <th>Net GP%</th>
              <th>Buyer</th>
              <th>Client PO</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="salesOrder"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <!-- <p-columnFilter
              type="text"
              field="createdDate"
              [showMenu]="false"
            ></p-columnFilter> -->
                  <jni-date-filter
                    (emitApplyFilter)="onFilterInputDate($event)"
                    (emitCancelFilter)="onFilterInputDate($event, 'clear')"
                    [columnName]="createdDateFieldName"
                    [filterMode]="filterMode"
                    [dataList]="filterOrdersWrittenReportDetailLists">
                  </jni-date-filter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="customerName"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="jobName"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <!-- <p-columnFilter
              type="date"
              field="inHandDate"
              [showMenu]="false"
            ></p-columnFilter> -->
                  <jni-date-filter
                    (emitApplyFilter)="onFilterInputDate($event)"
                    (emitCancelFilter)="onFilterInputDate($event, 'clear')"
                    [columnName]="inHandDateFieldName"
                    [filterMode]="filterMode"
                    [dataList]="filterOrdersWrittenReportDetailLists">
                  </jni-date-filter>
                </div>
              </th>
              <th>
                <!-- <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="brandingConsultant"
              id="brandingConsultant"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'brandingConsultant',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component"
            />
          </div> -->
                <p-columnFilter
                  type="text"
                  field="brandingConsultant"
                  [showMenu]="false"
                  (input)="onFilterInput($event)"></p-columnFilter>
              </th>
              <th>
                <!-- <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="accountCoordinator"
              id="accountCoordinator"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'accountCoordinator',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component"
            />
          </div> -->
                <p-columnFilter
                  type="text"
                  field="accountCoordinator"
                  [showMenu]="false"
                  (input)="onFilterInput($event)"></p-columnFilter>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="status"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <!-- <p-columnFilter
              type="text"
              field="highestNetVendor"
              [showMenu]="false"
            ></p-columnFilter> -->
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="buyer"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="clientPO"
                    [showMenu]="false"
                    (input)="onFilterInput($event)"></p-columnFilter>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-ordersWrittenReportDetailList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="ordersWrittenReportDetailList"
              [pSelectableRowIndex]="rowIndex">
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToSaleorder(
                      ordersWrittenReportDetailList.salesOrder
                    )
                  ">
                  {{ ordersWrittenReportDetailList.salesOrder }}
                </a>
              </td>

              <td>
                <span
                  *ngIf="
                    ordersWrittenReportDetailList?.createdDate
                      | hidedynamicsdate
                  ">
                  {{
                    ordersWrittenReportDetailList.createdDate
                      | date: "MM-dd-yyyy"
                  }}
                </span>
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClient(ordersWrittenReportDetailList.customerId)
                  ">
                  {{ ordersWrittenReportDetailList.customerName }}
                </a>
              </td>
              <td>{{ ordersWrittenReportDetailList.jobName }}</td>
              <td>
                {{ ordersWrittenReportDetailList.ihd | date: "MM-dd-yyyy" }}
              </td>
              <td>{{ ordersWrittenReportDetailList.brandingConsultant }}</td>
              <td>
                {{ ordersWrittenReportDetailList.accountCoordinator }}
              </td>
              <td>
                {{ ordersWrittenReportDetailList.status }}
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToVendor(ordersWrittenReportDetailList.vendorId)
                  ">
                  {{ ordersWrittenReportDetailList.highestNetVendor }}
                </a>
              </td>
              <td>
                {{ ordersWrittenReportDetailList.currency }}
              </td>
              <td>
                {{ ordersWrittenReportDetailList.orderSubTotal | currency }}
              </td>
              <td>
                {{ ordersWrittenReportDetailList.commission | currency }}
              </td>
              <td>
                {{ ordersWrittenReportDetailList.orderNetGP | number: "1.2-2" }}
              </td>
              <td>
                {{ ordersWrittenReportDetailList.buyer }}
              </td>
              <td>
                {{ ordersWrittenReportDetailList.clientPO }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
  <div>
    <jni-modal-stacker
      class="modal-header-sticky"
      *ngIf="orderDisplayModal"
      [displayModal]="orderDisplayModal"
      (closeEvent)="closeModalForSaleOrder()">
      <h1 class="panelHeading">Order Summary</h1>
      <div class="panelBody">
        <jni-order-summary
          [isModal]="true"
          [saleOrderIdFromModal]="saleOrderId"
          (scrollHiddenStatus)="scrollHiddenStatus()"
          (closeOrderSummaryModalEvent)="
            closeModalForSaleOrder()
          "></jni-order-summary>
      </div>
    </jni-modal-stacker>

    <jni-modal-stacker
      *ngIf="clientDisplayModal"
      [displayModal]="clientDisplayModal"
      (closeEvent)="closeModalForClient()">
      <h1 class="panelHeading">Client Summary</h1>
      <div class="panelBody">
        <jni-client-details
          [isModal]="true"
          [clientIdFromModal]="clientId"
          (closeEvent)="closeModalForClient()">
        </jni-client-details>
      </div>
    </jni-modal-stacker>

    <jni-modal-stacker
      *ngIf="vendorDisplayModal"
      [displayModal]="vendorDisplayModal"
      (closeEvent)="closeModal()">
      <h1 class="panelHeading">Vendor Summary</h1>
      <div class="panelBody">
        <jni-vendor-summary
          [vendorIdFromModal]="vendorAccountNumber"
          (emitcloseVendorModalStacker)="closeModal()"></jni-vendor-summary>
      </div>
    </jni-modal-stacker>
  </div>
</div>
